// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const klawf: PokeData = {
  "id": 950,
  "name": "klawf",
  "height": 13,
  "weight": 790,
  "base_experience": 158,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "guillotine",
    "swords-dance",
    "rock-throw",
    "harden",
    "rock-slide",
    "flail",
    "protect",
    "metal-claw",
    "rock-smash",
    "rock-tomb",
    "iron-defense",
    "rock-blast",
    "x-scissor",
    "high-horsepower"
  ],
  "moves": [
    "rock-throw",
    "rock-slide",
    "protect",
    "metal-claw",
    "rock-smash",
    "rock-tomb",
    "rock-blast",
    "ancient-power",
    "stone-axe",
    "stealth-rock",
    "stone-crush",
    "power-siphon",
    "seismic-toss"
  ],
  "evolution_chain": {
    "id": 497,
    "item": null,
    "species": [
      {
        "name": "klawf",
        "order": 962,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 123,
    "speed": 119,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
